import React, { useEffect, useState } from 'react';
import * as S from "./NumberButtonsStyle";

const NumberButtons = props => {

    const [numbers, setNumbers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]);

    useEffect(() => {
        document.addEventListener("keydown", onKeyDown);
    },[]);

    const onKeyDown = (event) => {
        if (event.key >= 0 && event.key <= 9) props.onSaveNumberBtnClick(event.key)
        document.removeEventListener("keydown", onKeyDown);
    };

    return <S.ButtonsContainer onKeyDown={onKeyDown}>
        {numbers.map((res, index) => {
            return (
              <S.BootstrapButton
                tabIndex="0"
                key={index}
                color="secondary"
                size="lg"
                value={res}
                onClick={(e) => props.onSaveNumberBtnClick(e.target.value)}
              >
                {res}
              </S.BootstrapButton>
            );
        })}
    </S.ButtonsContainer>;
};

export default NumberButtons;
